module.exports = __webpack_public_path__ + "media/images/common/mypage_btn-621d768ba7f083219b1199796688cef4.gif";